import React from 'react';
import PropTypes from 'prop-types';

const Button = (
  {
    classButton, children, disabled, href, type, onPress,
  },
) => (
  <button
    type={type}
    className={`button ${classButton}`}
    ref={href}
    disabled={disabled}
    onClick={onPress}
  >
    {children}
  </button>
);

Button.propTypes = {
  classButton: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  disabled: PropTypes.bool,
  href: PropTypes.string,
  type: PropTypes.string,
  onPress: PropTypes.func,
};

Button.defaultProps = {
  classButton: '',
  children: [],
  disabled: false,
  href: null,
  type: 'button',
  onPress: () => { },
};

export default Button;
